import React from 'react';
import { useParams, Link } from 'react-router-dom';
import PropertyGallery from '../components/PropertyGallery';
import ContactAgent from '../components/ContactAgent';
import { getProperties } from '../utils/propertyStorage';

const PropertyDetail = () => {
  const { id } = useParams();
  const allProperties = getProperties();
  const property = allProperties.find(prop => prop.id === parseInt(id));

  if (!property) {
    return (
      <div style={styles.notFound}>
        <h2>Nekretnina nije pronađena</h2>
        <p>Tražena nekretnina ne postoji u našem sustavu.</p>
        <Link to="/nekretnine" style={styles.backLink}>
          Pregledaj dostupne nekretnine
        </Link>
      </div>
    );
  }
  
  return (
    <div style={styles.container}>
      <div style={styles.breadcrumb}>
        <Link to="/nekretnine">Nekretnine</Link> &gt; {property.title}
      </div>
      
      <h1 style={styles.title}>{property.title}</h1>
      <p style={styles.location}>{property.location}</p>
      
      <PropertyGallery images={property.images} />
      
      <div style={styles.details}>
        <div style={styles.mainInfo}>
          <h2 style={styles.sectionTitle}>Detalji nekretnine</h2>
          <p style={styles.description}>{property.description}</p>
          
          <div style={styles.features}>
            <h3 style={styles.featuresTitle}>Karakteristike</h3>
            <ul style={styles.featuresList}>
              {property.features.map((feature, index) => (
                <li key={index} style={styles.featureItem}>{feature}</li>
              ))}
            </ul>
          </div>
        </div>
        
        <div style={styles.sidebar}>
          <div style={styles.priceBox}>
            <div style={styles.price}>€{property.price.toLocaleString()}</div>
            <div style={styles.infoItem}>
              <strong>Sobe:</strong> {property.bedrooms}
            </div>
            <div style={styles.infoItem}>
              <strong>Kupatila:</strong> {property.bathrooms}
            </div>
            <div style={styles.infoItem}>
              <strong>Površina:</strong> {property.area} m²
            </div>
          </div>
          
          <ContactAgent />
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '2rem 0',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  notFound: {
    textAlign: 'center',
    padding: '3rem'
  },
  backLink: {
    display: 'inline-block',
    marginTop: '1rem',
    padding: '10px 20px',
    backgroundColor: '#4a6fa5',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '4px'
  },
  breadcrumb: {
    marginBottom: '1rem',
    color: '#666'
  },
  title: {
    fontSize: '2rem',
    marginBottom: '0.5rem'
  },
  location: {
    fontSize: '1.2rem',
    color: '#666',
    marginBottom: '2rem'
  },
  details: {
    display: 'grid',
    gridTemplateColumns: '1fr 350px',
    gap: '2rem',
    marginTop: '2rem'
  },
  mainInfo: {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
  },
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem'
  },
  sectionTitle: {
    fontSize: '1.5rem',
    marginBottom: '1.5rem',
    paddingBottom: '0.5rem',
    borderBottom: '1px solid #eee'
  },
  description: {
    marginBottom: '2rem',
    lineHeight: '1.8'
  },
  features: {
    marginBottom: '2rem'
  },
  featuresTitle: {
    fontSize: '1.2rem',
    marginBottom: '1rem'
  },
  featuresList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '1rem',
    listStyle: 'none',
    padding: 0
  },
  featureItem: {
    padding: '0.5rem',
    backgroundColor: '#f8f9fa',
    borderRadius: '4px'
  },
  priceBox: {
    backgroundColor: 'white',
    padding: '1.5rem',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    textAlign: 'center'
  },
  price: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#4a6fa5',
    marginBottom: '1rem'
  },
  infoItem: {
    padding: '0.5rem 0',
    borderTop: '1px solid #eee'
  }
};

export default PropertyDetail;